/** A string returning a with decimal, defaults to 2dp */
export const formatNumberToDecimal = (amount: number, options: Intl.NumberFormatOptions | undefined =
{ style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }): string => new Intl.NumberFormat(navigator.language ?? 'en-GB', options).format(amount);
